var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"active_component"},[_c(_vm.tab.tabName,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }